export enum EStoreKeys {
  SUBMISSION_FORM = 'submission-form-storage',
  DASHBOARD_FILTERS = 'dashboard-filters-storage',
}
